import { alpha, Box, Collapse, makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { THEME_MODE } from "src/config/constants";
import ArrowAnimationIcon from "../Icon/ArrowAnimationIcon";

const useStyle = makeStyles((theme) => ({
  boxTitle: {
    margin: "0rem 0rem 0.75rem 0rem",
    cursor: "pointer",
  },
  open: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  close: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    color: theme.palette.text.hint,
    textTransform: "uppercase",
  },
  navLink: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.secondary,
    textDecoration: "none",
    padding: "0.5rem 0.4rem",
    marginTop: "0.5rem",
    borderRadius: "6px",
    background: "transparent",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
    "&:hover": {
      background: theme.palette.type === THEME_MODE.DARK ? "#FFFFFF0F" : "rgba(232, 234, 237, 0.7)",
    },
  },
  activeLink: {
    background: theme.palette.primary.main,
    color: "#FFFFFF",
    boxShadow: `0 0 10px 1px ${alpha(theme.palette.primary.main, 0.6)}`,
    "&:hover": {
      background: theme.palette.primary.main,
    },
  },
}));

export default function SidebarTab({ tabType, title, open }) {
  const cls = useStyle();
  const [isTransform, setTransform] = useState(true);
  const onArrowClick = () => {
    setTransform(!isTransform);
  };

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className={cls.boxTitle}
        onClick={() => onArrowClick()}
      >
        <Box display="flex" width="100%" className={clsx({ [cls.open]: open, [cls.close]: !open })}>
          <Typography variant="subtitle2" className={cls.title}>
            {title}
          </Typography>
        </Box>

        {open && <ArrowAnimationIcon isTransform={isTransform} className={cls.title} style={{ fontSize: "14px" }} />}
      </Box>
      <Collapse in={isTransform}>
        <Box>
          {tabType.map((element, index) => {
            const IconTag = element["icon"];

            return (
              <NavLink key={index} to={element["link"]} className={cls.navLink} activeClassName={cls.activeLink}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <IconTag style={{ width: 25, fontSize: "16px" }} />
                  {open && <Typography style={{ fontSize: "14px", fontWeight: 500 }}>{element["name"]}</Typography>}
                </Box>
              </NavLink>
            );
          })}
        </Box>
      </Collapse>
    </Box>
  );
}
